import * as api from "../api/index";

export const ReportService = {
  getFinanceReportData,
  searchUserByUserName,
  getFinanceReportDataChannelWise,
  getDataFinanceReportDataChannelWise
};

async function getFinanceReportData(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getFinanceReportData(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getFinanceReportDataChannelWise(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getFinanceReportDataChannelWise(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getDataFinanceReportDataChannelWise(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getDataFinanceReportDataChannelWise(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function searchUserByUserName(formData) {
  try {
    const { data } = await api.searchUserByUserName(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}